import React from 'react'

import Logo from 'components/Logo'
import { TextInput } from 'components/Common/Form'
import { Button, Modal } from 'components/Common'

import { styles } from './styles'

export const BillPayModal = ({ open, setOpen }) => {
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      header={'Bill Pay'}
      style={styles.modal}
      width={'70%'}
    >
      <div style={styles.container}>
        <Logo centered={false} style={styles.logo} />
        <div style={styles.content}>
          <div style={styles.title}>Bill Pay</div>
          <div style={styles.description}>Access your account with the account number found on your last statement.</div>
          <div style={styles.inputsContainer}>
            <TextInput label={'Account number'} style={styles.input} />
            <TextInput label={'Patient Date of Birth'} style={styles.input} />
            <TextInput label={'Guarantor Zip Code'} style={styles.input} />
          </div>
          <Button style={styles.button}>Continue</Button>
        </div>
      </div>
    </Modal>
  )
}
